import { IntegrationInterface } from '@interface/integration/integration.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialIntegrationsState: BaseStoreInterface<Record<string, IntegrationInterface>> = {
  ...BaseStoreStructure,
  data: {},
};
